import { render, staticRenderFns } from "./FilesEndorsements.vue?vue&type=template&id=42075a6a&scoped=true&"
import script from "./FilesEndorsements.vue?vue&type=script&lang=js&"
export * from "./FilesEndorsements.vue?vue&type=script&lang=js&"
import style0 from "./FilesEndorsements.vue?vue&type=style&index=0&id=42075a6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42075a6a",
  null
  
)

export default component.exports